export default __webpack_public_path__ + "static/img/download_app_unsafe_details_image.311f69e.png";